package dev.akshaychordiya.components.widgets

import androidx.compose.runtime.Composable
import dev.akshaychordiya.content.talks
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun TalkStats() {
    val total = talks.size
    val cities = talks.mapNotNull { it.city?.name }.distinct().size
    val countries = talks.mapNotNull { it.city?.country }.distinct().size
    
    P {
        Text("I've given ")
        A(href = "/talks") {
            Text("$total talks across $cities cities and $countries countries")
        }
        Text(" - droidcon London, Berlin, NYC, Orlando, San Francisco, Nairobi and India, Android Makers in Paris, and plenty of local meetups before any of that. Most recently I keynoted Android Makers on what an Android career looks like in an AI era.")
    }
}
